import { reactive } from 'vue';

export const assumedOrgState = reactive({
  org: null,
  role: null,
});

// Current product flags for the org on screen. Filled from the server.
// The saved login copy is only a stand-in until this arrives.
export const activeOrgFlags = reactive({
  orgId: null,
  features: null,
});

export function setActiveOrgFlags(orgId, features) {
  activeOrgFlags.orgId = orgId;
  activeOrgFlags.features = features || {};
}

export function setAssumedOrg(org, role) {
  assumedOrgState.org = org;
  assumedOrgState.role = role;
  if (org) {
    localStorage.setItem('assumed_org', JSON.stringify({ org, role }));
  } else {
    localStorage.removeItem('assumed_org');
  }
}

// Patch display fields on the current assumed org without replacing the object,
// so watchers on `assumedOrgState.org` (which reload whole pages) do not fire.
export function updateAssumedOrgFields(fields) {
  if (!assumedOrgState.org) return;
  Object.assign(assumedOrgState.org, fields);
  localStorage.setItem('assumed_org', JSON.stringify({ org: assumedOrgState.org, role: assumedOrgState.role }));
}

export function clearAssumedOrg() {
  setAssumedOrg(null, null);
}

// Call once on app startup to survive page refreshes
export function restoreAssumedOrg() {
  try {
    const saved = localStorage.getItem('assumed_org');
    if (saved) {
      const { org, role } = JSON.parse(saved);
      assumedOrgState.org = org;
      assumedOrgState.role = role;
    }
  } catch {
    localStorage.removeItem('assumed_org');
  }
}

// Run immediately at module load so assumedOrgState is populated
// before any component's onMounted fires (children mount before App.vue)
restoreAssumedOrg();
